import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sets the browser tab title for a page.
 * Resets to base title on unmount.
 * @param {string} title - Page-specific title (e.g., "Search Results")
 */
export default function usePageTitle(title) {
  const { t } = useTranslation('common');

  useEffect(() => {
    const baseTitle = t('brand');
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    return () => { document.title = baseTitle; };
  }, [title, t]);
}
